module.exports = __webpack_public_path__ + "img/20200117155440763.504268f1.jpg";